import { proxy } from "valtio";

import type { State } from "./types";

export const state = proxy<State>({
  spot: null,
  endInterviewStatus: null,
  endInterviewLoadingStatus: "READY",
});
